import { render, staticRenderFns } from "./AdminNotificationCreate.vue?vue&type=template&id=08fae63b&"
import script from "./AdminNotificationCreate.vue?vue&type=script&lang=js&"
export * from "./AdminNotificationCreate.vue?vue&type=script&lang=js&"
import style0 from "./AdminNotificationCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports